/** @type {import('../help-index.js').HelpSidebarItem} */
export const TAX_IVA_DDJJ_VENTAS_ITEM = {
  id: 'sub_nav_2',
  screenId: 'tax-iva-ddjj-libro-ventas',
  label: 'DDJJ — Libro IVA Ventas',
  description: 'Consulta del libro IVA ventas del sistema.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Ves todas las operaciones de venta con IVA del período: comprobantes emitidos, bases, alícuotas e importes, alineados con lo que declarás.',
      },
      {
        title: 'Paso 1 — Filtrar',
        fields: [
          { label: 'Desde / Hasta', description: 'Rango de fechas de comprobante. Tocá «Buscar».' },
        ],
      },
      {
        title: 'Paso 2 — Leer la lista',
        bullets: [
          'Columnas: fecha, tipo comprobante, número, cliente, CUIT/DNI, neto, IVA, total, etc.',
          'Totales al pie. Tocá una fila para abrir el comprobante de venta.',
          'Exportable.',
        ],
      },
    ],
  },
}
